import { Col, Container, OverlayTrigger, Row, Tooltip } from "react-bootstrap";
import useQuery from "../../hooks/useQuery";
import UECard from "../UECard";
import "../../styles/TabTipoUso.css";
import { useContext, useEffect, useState } from "react";
import ModalPopup from "../ModalPopup";
import { readCurrentState, sendCurrentState, StepContext } from "../StepContext";

import img_elettricita from "../../img/elettricita.png"
import img_gas from "../../img/gas.png"
import img_eg from "../../img/eg.png"

var msgText = '';
var msgTitle = '';

var readURLParams = true;



function TabTipoUso(props) {

    let cls = "divTipoUso mb-2 justify-content-center";
    if (props.selected) {
        cls += " selected";
    }

    const handleClick = () => {
        if (!props.disabled) {
            props.onClick();
        }
    }

    const el_style = () => {
        if (props.disabled) {
            return { display: 'flex', opacity: "0.5", margin: "0 auto" };
        } else {
            return { display: 'flex', margin: "0 auto" };
        }
    };



    return <OverlayTrigger overlay={props.disabled ? <Tooltip id="tooltip-disabled1">L'offerta selezionata non prevede la scelta del tipo d'uso {props.title}, se vuoi attivare un'offerta per {props.title} contatta il Servizio Clienti</Tooltip> : <Tooltip style={{ visibility: "hidden" }} />}>
        <span className="d-inline-block">
            <Row className={cls} onClick={handleClick} style={el_style()}  >
                <Col className="tuLeftBox col-3 pt-2">
                    <img src={props.src} width="50px" />
                    <br />
                    <b>{props.title}</b>
                </Col>
                <Col className="text-left text-md-center" style={{ textAlign: "left", lineHeight: "20px", fontSize: "14px" }}>
                    {props.text}
                </Col>
            </Row>
        </span>
    </OverlayTrigger>;
}


function Step2() {
    let query = useQuery();

    const { step, setStep } = useContext(StepContext);

    const [modalShow, setModalShow] = useState(false);

    const [gas, setGas] = useState(false);
    const [ee, setEE] = useState(false);
    const [eg, setEG] = useState(false);

    const [tp_ee_domestico, setTp_ee_domestico] = useState(false);
    const [tp_ee_altri, SetTp_ee_altri] = useState(false);

    const [tp_gas_domestico, setTp_gas_domestico] = useState(false);
    const [tp_gas_condominio, SetTp_gas_condominio] = useState(false);
    const [tp_gas_altri, SetTp_gas_altri] = useState(false);

    useEffect(() => {
        if (readURLParams || (step <= 2)) {
            MostraDatiGet();
            readURLParams = false;
        } else {
            //console.log(step);
            MostraDatiLocalStorage();
        }


    }, []);


    function MostraDatiLocalStorage() {
        //console.log("MostraDatiLocalStorage");

        let fa = readCurrentState('fornitura').toLowerCase();
        //console.log("parametro fa: " + fa);
        if (fa == 'gas') {
            gasClick();
        }
        if (fa == 'ee') {
            eeClick();
        }

        setTp_ee_domestico(readCurrentState("uso_ee") == '20');
        SetTp_ee_altri(readCurrentState("uso_ee") == '21');

        setTp_gas_domestico(readCurrentState("uso_gas") == '10');
        SetTp_gas_altri(readCurrentState("uso_gas") == '11');
        SetTp_gas_condominio(readCurrentState("uso_gas") == '16');
    }

    function MostraDatiGet() {
        //console.log("MostraDatiGet s2");

        if (query.has("fa")) {
            let fa = query.get("fa").toLowerCase();
            console.log("parametro fa: " + fa);
            if (fa == 'g') {
                gasClick();
            }
            if (fa == 'e') {
                eeClick();
            }

            //console.log("gas: " + (fa == 'g'));
            //console.log("ee: " + (fa == 'e'));
            //console.log("**gas:" + gas);
            //console.log("**ee:" + ee);


            if (query.has("tp")) {
                //console.log("parametro fa: " + fa);
                setTp_ee_domestico(query.get("tp") == '20');
                SetTp_ee_altri(query.get("tp") == '21');

                setTp_gas_domestico(query.get("tp") == '10');
                SetTp_gas_altri(query.get("tp") == '11');
                SetTp_gas_condominio(query.get("tp") == '16');
            }

        }
    }

    function disabilitaTastiFornitura(f) {
        if (query.has("fa")) {
            if ((f == "e") && (!ee)) {
                return true;
            } else
                if ((f == "g") && (!gas)) {
                    return true;
                } else
                    if ((f == "eg") && (!eg)) {
                        return true;
                    } else {
                        return false;
                    }
        } else {
            return false;
        }
    }

    function DisabilitaTastiUso(f) {
        if (query.has("tp")) {
            if ((f == "20") && (!tp_ee_domestico)) {
                return true;
            } else if ((f == "21") && (!tp_ee_altri)) {
                return true;
            } else if ((f == "10") && (!tp_gas_domestico)) {
                return true;
            } else if ((f == "11") && (!tp_gas_altri)) {
                return true;
            } else if ((f == "16") && (!tp_gas_condominio)) {
                return true;
            } else {
                return false;
            }
        } else {
            return false;
        }
    }

    function gasClick(e) {
        setGas(true);
        setEE(false);
        setEG(false);
    }
    function eeClick(e) {
        //console.log('eeClick');
        setGas(false);
        setEE(true);
        setEG(false);
    }
    function egClick(e) {
        setGas(false);
        setEE(false);
        setEG(true);
    }

    function activeOption(f) {
        let active = "ue btn btn-q btn-yellow active_f";
        let noactive = "ue btn btn-q btn-yellow";

        if ((f == 'g') && (gas)) {
            return active;
        } else if ((f == 'e') && (ee)) {
            return active;
        } else if ((f == 'eg') && (eg)) {
            return active;
        } else {
            return noactive;
        }
    }

    function tipiColVisible(f) {
        if ((f == 'e') && ((ee) || (eg))) {
            return '';
        } else if ((f == 'g') && ((gas) || (eg))) {
            return '';
        } else {
            return 'd-none';
        }
    }

    function Validation() {
        if ((!ee) && (!gas) && (!eg)) {
            msgText = 'Seleziona la tipologia di utenza che vuoi portare in Umbria Energy';
            msgTitle = 'Informazioni non valide o mancanti';
            setModalShow(true);
            return false;
        }

        if ((ee) || (eg)) {
            if ((!tp_ee_domestico) && (!tp_ee_altri)) {
                msgText = 'Seleziona seleziona il tipo uso per la LUCE';
                msgTitle = 'Informazioni non valide o mancanti';
                setModalShow(true);
                return false;
            }
        }
        if ((gas) || (eg)) {
            if ((!tp_gas_domestico) && (!tp_gas_altri) && (!tp_gas_condominio)) {
                msgText = 'Seleziona seleziona il tipo uso per il GAS';
                msgTitle = 'Informazioni non valide o mancanti';
                setModalShow(true);
                return false;
            }
        }

        let fornitura = '';
        if (ee) {
            fornitura = 'ee';
        } else if (gas) {
            fornitura = 'gas';
        } else if (eg) {
            fornitura = 'eg';
        }

        let uso_ee = null;
        if (tp_ee_domestico) {
            uso_ee = '20'
        } else
            if (tp_ee_altri) {
                uso_ee = '21'
            }

        let uso_gas = null;
        if (tp_gas_domestico) {
            uso_gas = '10'
        } else
            if (tp_gas_altri) {
                uso_gas = '11'
            }
            else
                if (tp_gas_condominio) {
                    uso_gas = '16'
                }

        let conx = {
            step: step,
            fornitura: fornitura,
            uso_ee: uso_ee,
            uso_gas: uso_gas
        };

        StepContext.contratto = { ...StepContext.contratto, ...conx };
        sendCurrentState();

        return true;
    }

    function TastiFornitura() {
        if (query.has("fa")) {
            return <>
                <OverlayTrigger overlay={disabilitaTastiFornitura('e') ? <Tooltip id="tooltip-disabled1">L'offerta selezionata non prevede la scelta della fornitura Luce, se vuoi attivare un'offerta Luce contatta il Servizio Clienti</Tooltip> : <Tooltip style={{ visibility: "hidden" }} />}>
                    <span className="d-inline-block">
                        <button style={{ pointerEvents: 'none' }}  id="f_e" className={activeOption("e")} onClick={eeClick} disabled={disabilitaTastiFornitura('e')} ><span><img src={img_elettricita}></img></span><br />LUCE</button>
                    </span>
                </OverlayTrigger>
                <OverlayTrigger overlay={disabilitaTastiFornitura('g') ? <Tooltip id="tooltip-disabled1">L'offerta selezionata non prevede la scelta della fornitura Gas, se vuoi attivare un'offerta Gas contatta il Servizio Clienti</Tooltip> : <Tooltip style={{ visibility: "hidden" }} />}>
                    <span className="d-inline-block">
                        <button style={{ pointerEvents: 'none' }} id="f_g" className={activeOption("g")} onClick={gasClick} disabled={disabilitaTastiFornitura('g')}><span><img src={img_gas}></img></span><br />GAS</button>
                    </span>
                </OverlayTrigger>
                            {/*  <OverlayTrigger overlay={disabilitaTastiFornitura('eg') ? <Tooltip id="tooltip-disabled1">L'offerta selezionata non prevede la scelta della fornitura Gas e Luce, se vuoi attivare un'offerta Gas e Luce contatta il Servizio Clienti</Tooltip> : <Tooltip style={{ visibility: "hidden" }} />}>
                        <span className="d-inline-block">
                            <button style={{ pointerEvents: 'none' }} id="f_eg" className={activeOption("eg")} onClick={egClick} disabled={disabilitaTastiFornitura('eg')}><span><img src={img_eg}></img></span><br />LUCE + GAS</button>
                        </span>
                    </OverlayTrigger>*/}
            </>
        }else{
            return <>
                    <span className="d-inline-block">
                        <button id="f_e" className={activeOption("e")} onClick={eeClick}  ><span><img src={img_elettricita}></img></span><br />LUCE</button>
                    </span>
                    <span className="d-inline-block">
                        <button id="f_g" className={activeOption("g")} onClick={gasClick} ><span><img src={img_gas}></img></span><br />GAS</button>
                    </span>
                    {/* <span className="d-inline-block">
                            <button style={{ pointerEvents: 'none' }} id="f_eg" className={activeOption("eg")} onClick={egClick} disabled={disabilitaTastiFornitura('eg')}><span><img src={img_eg}></img></span><br />LUCE + GAS</button>
                        </span>
        */}
            </>
        }
    }

    //TODO: leggi da get
    //TODO: leggi da localStorage

    //nasconde col d-none
    return (
        <UECard BackButton={true} NextButton={true} className="S1Div" style={{ marginLeft: "250px", width: "100%", textAlign: "center", marginTop: "50px" }} onValidate={Validation}>
            <h2 style={{ color: "green" }}>Voglio portare in Umbria Energy la mia utenza</h2>
            <h2>Scegli che tipo di fornitura*</h2>
            <Row className="justify-content-center" style={{ display: 'flex' }} >
                <Col className="text-center text-md-right">
                    {TastiFornitura()}
                </Col>
            </Row>
            <hr />
            <Container className="container-fluid">
                <Row className="justify-content-center" style={{ display: 'flex' }} >
                    <Col className={"text-center text-md-right " + tipiColVisible('e')}>
                        <h4>Scegli il tipo uso per la <b>LUCE</b>*</h4>
                        <TabTipoUso title="DOMESTICO"
                            src="https://cdn-icons-png.flaticon.com/512/2413/2413074.png"
                            text="È l’energia elettrica destinata a una casa, indipendentemente che sia quella di residenza o quella dove trascorri le vacanze, sia essa di proprietà o in affitto"
                            selected={tp_ee_domestico}
                            disabled={DisabilitaTastiUso("20")}
                            onClick={() => { setTp_ee_domestico(true); SetTp_ee_altri(false); }} />

                        <TabTipoUso title="ALTRI USI"
                            src="https://cdn-icons-png.flaticon.com/512/126/126122.png"
                            text="È l’energia elettrica destinata ad un negozio, un’attività commerciale, un’impresa, un ufficio pubblico, un garage, un condominio o un’associazione"
                            selected={tp_ee_altri}
                            disabled={DisabilitaTastiUso("21")}
                            onClick={() => { setTp_ee_domestico(false); SetTp_ee_altri(true); }} />
                    </Col>
                    <Col className={"text-center text-md-right " + tipiColVisible('g')}>
                        <h4>Scegli il tipo uso per il <b>GAS</b>*</h4>
                        <TabTipoUso title="DOMESTICO"
                            src="https://cdn-icons-png.flaticon.com/512/2413/2413074.png"
                            text="È il contratto del gas intestato a una persona fisica, che utilizza per alimentare un’abitazione e i locali annessi o pertinenti all’abitazione (riscaldamento, cottura cibi, produzione acqua calda)"
                            selected={tp_gas_domestico}
                            disabled={DisabilitaTastiUso("10")}
                            onClick={() => { setTp_gas_domestico(true); SetTp_gas_altri(false); SetTp_gas_condominio(false); }} />
                        <TabTipoUso title="CONDOMINIO USO DOMESTICO"
                            src="https://cdn-icons-png.flaticon.com/512/126/126122.png"
                            text="È il contratto che alimenta un intero edificio, diviso in più unità catastali, in cui ci sia almeno una unità abitativa con utilizzi analoghi a quelli di un cliente domestico.
                        Può anche essere intestato ad una persona giuridica a patto che svolga le funzioni di amministratore del condominio e non sia una società che fornisce servizi di gestione calore o energia.
                        "
                            selected={tp_gas_condominio}
                            disabled={DisabilitaTastiUso("16")}
                            onClick={() => { setTp_gas_domestico(false); SetTp_gas_altri(false); SetTp_gas_condominio(true); }} />
                        <TabTipoUso title="ALTRI USI"
                            src="https://cdn-icons-png.flaticon.com/512/3438/3438476.png"
                            text="È il contratto intestato a persona fisica o giuridica, che usa il gas per usi diversi da quelli Domestici, Condominiali Uso Domestico e Uso Pubblico"
                            selected={tp_gas_altri}
                            disabled={DisabilitaTastiUso("11")}
                            onClick={() => { setTp_gas_domestico(false); SetTp_gas_altri(true); SetTp_gas_condominio(false); }} />
                    </Col>
                </Row>
            </Container>
            <ModalPopup title={msgTitle} message={msgText} show={modalShow} onHide={() => setModalShow(false)} />
        </UECard>

    );
}


export default Step2;